/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskBusinessName
 */
export interface ExecRiskBusinessName {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskBusinessName
     */
    business_name_line_1_txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskBusinessName
     */
    business_name_line_2_txt?: string;
}

/**
 * Check if a given object implements the ExecRiskBusinessName interface.
 */
export function instanceOfExecRiskBusinessName(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskBusinessNameFromJSON(json: any): ExecRiskBusinessName {
    return ExecRiskBusinessNameFromJSONTyped(json, false);
}

export function ExecRiskBusinessNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskBusinessName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'business_name_line_1_txt': !exists(json, 'business_name_line_1_txt') ? undefined : json['business_name_line_1_txt'],
        'business_name_line_2_txt': !exists(json, 'business_name_line_2_txt') ? undefined : json['business_name_line_2_txt'],
    };
}

export function ExecRiskBusinessNameToJSON(value?: ExecRiskBusinessName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'business_name_line_1_txt': value.business_name_line_1_txt,
        'business_name_line_2_txt': value.business_name_line_2_txt,
    };
}

